export default "__VITE_ASSET__C04n2ad2__"